<template>
    <ac-modal title="Confirm Email Address" ref="modalRef" :size-class="''" @ac-modal-closed="cancel">
        <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <input type="text" class="form-control " v-model="emailAddress" />
                </div>
            </div>
        </div>
        <br/>
        <div class="modal-footer">
            <div>
                <ac-button class="btn btn-green btn-sm" :action="save">SEND</ac-button>
                <ac-button class="btn btn-red btn-sm" :action="cancel">CANCEL</ac-button>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    export default {
        name: "EmailOverrideModal",
        inheritAttrs: false,
        components: {},
        data() {
            return {
                emailAddress: ""
            };
        },
        methods: {
            async showModal(targetEmailAddress) {
                this.emailAddress = targetEmailAddress;
                this.$refs.modalRef.open();
                return new Promise((resolve, reject) => {
                    this.successReference = resolve;
                });
            },
            cancel() {
                this.successReference("");
                this.$refs.modalRef.close();
            },
            async save() {
                this.successReference(this.emailAddress);
                this.$refs.modalRef.close();
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0; 
    }
    .modal-body {
        padding-bottom: 0;
        padding-top:0;
    }
</style>